/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRecurringCheckCall.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/recurring-check-call";

export class AutogenModelRecurringCheckCall<RowType extends ModelRow> extends Endpoint<RowType, RowRecurringCheckCallFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRecurringCheckCall extends ModelRow<RowRecurringCheckCallFields> {
	constructor(values?: Partial<RowRecurringCheckCallFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRecurringCheckCallFields {
	checkcall_sched_id: string;
	company_id: string;
	end_time: string;
	friday: string;
	id: string;
	monday: string;
	rec_interval: number;
	saturday: string;
	start_time: string;
	sunday: string;
	thursday: string;
	tuesday: string;
	wednesday: string;
}

